import { deal, dealHistorical, deals, funnel, task } from '@/services/axios'

import Vue from 'vue'

export const contractAttendanceTasks = {
    namespaced: true,

    state: {
        attendanceTasks: true,
        dealId: undefined,
        lengthDataTasks: 0,
        customerName: '',
        historicalData: {
            historical: [],
            pagination: {
                page: 1,
                last_page: 0,
                total: null,
                current_page: 0
            },
        },
        tasksData: {
            tasks: [],
            pagination: {
                page: 1,
                last_page: 0,
                total: null,
                to: 0
            },
        }
    },

    getters: {
        getDealId(state) {
            return state.dealId
        },

        getCustomerName(state) {
            return state.customerName
        },

        getLengthDataTasks(state) {
            return state.lengthDataTasks
        },

        getHistorical(state) {
            return state.historicalData
        },

        getTasks(state) {
            return state.tasksData
        }
    },

    mutations: {
        SET_INITIAL_CARDS(state, payload) {
            state.customerName = payload.data.customer.name
            state.lengthDataTasks = payload.data.tasks.length
        },

        SET_DEAL_ID(state, payload) {
            state.dealId = payload
        },

        SET_HISTORICAL_CARDS(state, payload) {
            const combinedCards = [...state.historicalData.historical, ...payload.data]

            // Remover duplicatas com base no 'id'
            state.historicalData.historical = combinedCards.filter((card, index, self) =>
                index === self.findIndex(c => c.id === card.id)
            )

            state.historicalData.pagination = {
                page: state.historicalData.pagination.page + 1,
                last_page: payload.last_page,
                total: payload.total,
                current_page: payload.current_page
            }
        },

        SET_CREATE_DEAL_HISTORICAL_CARDS(state, payload) {
            state.historicalData.historical.unshift(payload.data)
        },

        SET_DELETE_DEAL_HISTORICAL_CARDS(state, payload) {
            // Remover card
            state.historicalData.historical = state.historicalData.historical.filter(card => card.id !== payload)
        },

        SET_TASKS_CARDS(state, payload) {
            const combinedCards = [...state.tasksData.tasks, ...payload.data]

            // Remover duplicatas com base no 'id'
            state.tasksData.tasks = combinedCards.filter((card, index, self) =>
                index === self.findIndex(c => c.id === card.id)
            ).sort((a, b) => b.id - a.id)
            state.tasksData.pagination = {
                page: state.tasksData.pagination.page + 1,
                last_page: payload.last_page,
                total: payload.total,
                to: payload.to
            }
            state.lengthDataTasks = payload.total
        },

        SET_CREATE_DEAL_TASKS_CARDS(state, payload) {
            state.tasksData.tasks.unshift(payload.data.task)
            state.lengthDataTasks = state.lengthDataTasks + 1
        },

        SET_DELETE_DEAL_TASKS_CARDS(state, payload) {
            // Remover card
            state.tasksData.tasks = state.tasksData.tasks.filter(card => card.id !== payload)
            state.lengthDataTasks = state.lengthDataTasks - 1
        },

        UPDATE_DEAL_TASKS(state, payload) {
            const index = state.tasksData.tasks.findIndex(card => card.id == payload.dataForm.id)
            const updatedUsers = state.tasksData.tasks[index].users

            if (index !== -1) {
                state.tasksData.tasks[index] = { ...payload.dataForm, users: updatedUsers }
            }
        }
    },

    actions: {
        async getInitialCards({ commit }, payload) {
            const dealId = parseInt(payload)

            commit('SET_DEAL_ID', dealId)

            try {
                const { data } = await funnel.getDeal(dealId)

                commit('SET_INITIAL_CARDS', data)
            } catch (error) {
                if (error?.data?.msg) Vue.prototype.$toastr.e(error.data.msg)
            }
        },

        async getHistoricalCards({ commit, getters }, payload) {
            const page = payload
            try {
                const { data } = await deals.get(getters.getDealId, `historical?per_page=15&page=${page}`)

                commit('SET_HISTORICAL_CARDS', data)
            } catch (error) {
                if (error?.data?.msg) Vue.prototype.$toastr.e(error.data.msg)
            }
        },

        async createDealHistorical({ commit }, payload) {
            const form = payload
            try {
                const { data } = await dealHistorical.create('', form)

                commit('SET_CREATE_DEAL_HISTORICAL_CARDS', data)
                Vue.prototype.$toastr.s(data.msg)
            } catch (error) {
                if (error?.data?.msg) Vue.prototype.$toastr.e(error.data.msg)
            }
        },

        async deleteDealHistorical({ commit }, payload) {
            const idCard = payload
            try {
                const { data } = await dealHistorical.delete('', idCard)

                commit('SET_DELETE_DEAL_HISTORICAL_CARDS', idCard)
                Vue.prototype.$toastr.s(data.msg)
            } catch (error) {
                if (error?.data?.msg) Vue.prototype.$toastr.e(error.data.msg)
            }
        },

        async getTasksCards({ commit, getters }, payload) {
            const page = payload
            try {
                const { data } = await deal.get(getters.getDealId, `tasks?per_page=15&page=${page}`)
                commit('SET_TASKS_CARDS', data)
            } catch (error) {
                if (error?.data?.msg) Vue.prototype.$toastr.e(error.data.msg)
            }
        },

        async createDealTasks({ commit }, payload) {
            const form = payload
            try {
                const { data } = await task.create('', form)

                commit('SET_CREATE_DEAL_TASKS_CARDS', data)
                Vue.prototype.$toastr.s(data.msg)
            } catch (error) {
                if (error?.data?.msg) Vue.prototype.$toastr.e(error.data.msg)
            }
        },

        async deleteDealTasks({ commit }, payload) {
            const idCard = payload
            try {
                const { data } = await task.delete('', idCard)

                commit('SET_DELETE_DEAL_TASKS_CARDS', idCard)
                Vue.prototype.$toastr.s(data.msg)
            } catch (error) {
                if (error?.data?.msg) Vue.prototype.$toastr.e(error.data.msg)
            }
        },

        updateDealTasks({ commit }, payload) {
            commit('UPDATE_DEAL_TASKS', payload)
        }
    }
}